/*
 * Durations: the API keeps SLA targets in minutes; people read and type hours
 * and business days.
 */
/** A business day: 08:00–17:30. */
export const BUSINESS_DAY = 570;

/** 60 → "1 hour", 570 → "1 business day", 30 → "30 minutes". */
export const minutesLabel = (minutes, businessHours = true) => {
  const m = Number(minutes);
  if (!m && m !== 0) return "—";
  const plural = (n, w) => `${n} ${w}${n === 1 ? "" : "s"}`;
  if (businessHours && m >= BUSINESS_DAY && m % BUSINESS_DAY === 0) return plural(m / BUSINESS_DAY, "business day");
  if (m >= 60 && m % 60 === 0) return plural(m / 60, "hour");
  if (m > 60) return `${Math.floor(m / 60)} h ${m % 60} min`;
  return plural(m, "minute");
};

/** "4 hours", "1 business day", "30 minutes", "2 days" → minutes; null when unreadable. */
export const parseDuration = (text) => {
  const t = String(text ?? "").trim().toLowerCase();
  if (/^\d+$/.test(t)) return Number(t);
  const m = t.match(/^(\d+(?:\.\d+)?)\s*(business days?|days?|hours?|hrs?|h|minutes?|mins?|m)$/);
  if (!m) return null;
  const n = Number(m[1]);
  const unit = m[2];
  if (unit.startsWith("business")) return Math.round(n * BUSINESS_DAY);
  if (unit.startsWith("day")) return Math.round(n * 1440);
  if (unit.startsWith("h")) return Math.round(n * 60);
  return Math.round(n);
};
